import useViewConfig from './useViewConfig';

const useResourceDisplayName = (resource: string) => {
    const viewConfig = useViewConfig();
    return viewConfig.entities[resource] && viewConfig.entities[resource].displayName;
};

export default useResourceDisplayName;
